import Automobiles from "./Automobiles";

export default Automobiles;